import type { ReactNode } from 'react'

export interface FilterBarProps {
  children: ReactNode
  rightSlot?: ReactNode
}

export function FilterBar({ children, rightSlot }: FilterBarProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-4 mb-6">
      <div className="flex flex-1 items-center gap-4">
        <div className="text-charcoal-50 whitespace-nowrap">
          <span className="mr-1">Filter</span>
          <i className="fa-solid fa-filter"></i>
        </div>
        <div className="flex gap-4 overflow-x-auto sm:overflow-x-hidden sm:flex-wrap">
          {children}
        </div>
      </div>
      {rightSlot && <div className="shrink-0">{rightSlot}</div>}
    </div>
  )
}
